import { isFunction } from 'lodash'
import moment from 'moment'

import { HtmlEntities } from '@wf-sl/common-utilities'

import { isValidISO8601 } from '../validator/is-valid-iso-8601'
import { THROW_INTL_ERROR_MESSAGE } from '../constants'

/**
 * Get formatted date string.
 *
 * @param {Intl} intl - Global modux intl helper.
 * @param {string} date - The date to be parsed.
 * @param {Object} [formatConfig={}] - The formatting configuration.
 * @param {string} [formatConfig.separator='&nbsp;'] - The separator between date and time.
 * @param {string} [formatConfig.suffix=',&nbsp;'] - The suffix string at the end.
 * @param {string} [formatConfig.dateFormatter='dateWoYear'] suffix - The format string.
 * @param {string} [formatConfig.defaultTime='defaultTime'] suffix - The format string.
 * @returns {string} The formatted date
 */
export function getShortDateAndShortTime(intl, date, formatConfig = {}) {
    if (!intl || !isFunction(intl.formatDate)) {
        throw new Error(THROW_INTL_ERROR_MESSAGE)
    }

    let givenDate = null

    if (isValidISO8601(date)) {
        givenDate = moment(date).toDate()
    } else {
        return HtmlEntities.MDASH
    }

    const config = Object.assign(
        {
            dateFormatter: 'dateWoYear',
            separator: ' ',
            suffix: ', ',
            timeFormatter: 'defaultTime'
        },
        formatConfig
    )

    const formattedDate = intl.formatDate(givenDate, config.dateFormatter)
    const formattedTime = intl.formatDate(givenDate, config.timeFormatter)

    return `${formattedDate}${config.separator}${formattedTime}${config.suffix}`
}
